import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import qs from 'query-string';
import { withRouter } from 'react-router';

import CreateSubscriptionModal from './CreateSubscriptionModals';
import { ReactComponent as ExclamationIcon } from '../../images/icons/exclamation_circle.svg';
import { ReactComponent as TickIcon } from '../../images/icons/tick.svg';
import { ReactComponent as CloseIcon } from '../../images/icons/close.svg';
import ContactModal from './ContactModal';
import AppContext from '../app/AppContext';
import SelectSizeTierModal from './SelectSizeTierModal';
import { mapCurrencyToSign } from '../../utils';
import mixpanel from 'mixpanel-browser';
import { localiseText } from '../../utils';

class FreeAccount extends React.Component {
    static contextType = AppContext;

    constructor (props) {
        super(props);
        this.state = {
            selectedInvoice: null,
            payInvoiceModalOpen: false,
            newPaymentMethodModalOpen: false,
            editDetailsModalOpen: false,
            cancelSubscriptionModalOpen: false,
            upgradeEvent: {},
            upgradeModalOpen: false,
            downgradeEvent: {},
            downgradeModalOpen: false,
            refreshEvents: false,
            openEmptyUpgradeModal: false,
            perks: [],
            isShowSelectSizeTierModal: false,
            isShowContactModal: false,
            annualPlanPrice: {},
        };
    }

    componentDidMount () {
        const token = this.context.token ? this.context.token : localStorage.getItem('token');
        const apiCallURL = `${process.env.REACT_APP_API_URL}/api/react/lookup/subscription_perks/`;
        const headers = {
            Authorization: `Token ${token}`,
        };
        axios
            .get(apiCallURL, { headers })
            .then(res => {
                this.setState({
                    perks: res.data.data,
                });
            })
            .catch(error => {
                console.log(error);
            });

        this.getTierPlan();

        const queryParams = qs.parse(this.props.location.search);

        if (queryParams?.redirect_status) {
            this.setState({
                upgradeModalOpen: true,
            });
        }
    }

    getTierPlan = () => {
        const token = this.context.token ? this.context.token : localStorage.getItem('token');
        const headers = {
            Authorization: `Token ${token}`,
        };
        axios
            // eslint-disable-next-line max-len
            .get(`${process.env.REACT_APP_API_URL}/api/react/organisations/${this.context.selectedOrganisation.id}/subscriptions/get_tier_plan/`, { headers })
            .then(({ data }) => {
                this.setState({
                    annualPlanPrice: data.data.find(item => item?.paycycle === 'A').plan_price[0],
                    currentTier: data.data.find(item => item?.paycycle === 'A').title,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    handleUpgradeEvent = (event, eventsList) => this.setState({
        upgradeEvent: event,
        upgradeModalOpen: true,
        eventsList
    });

    handleUpgradeCancel = (refreshEvents = false) => this.setState({
        upgradeEvent: {},
        upgradeModalOpen: false,
        eventsList: []
    }, () => {
        if (refreshEvents)
            this.props.updateSubData(false);
    });

    toggleIsShowSelectSizeTierModal = () => {
        this.setState(prevState => ({
            isShowSelectSizeTierModal: !prevState.isShowSelectSizeTierModal,
        }));
    };

    toggleContactModal = () => {
        this.setState(prevState => ({
            isShowContactModal: !prevState.isShowContactModal,
        }));
    }

    handleContinueUpgradeToPremium = (sizeTier) => {
        this.toggleIsShowSelectSizeTierModal();
        if (sizeTier === 'TR5') {
            return this.toggleContactModal();
        }
        this.getTierPlan();
        this.setState({
            upgradeModalOpen: true,
        });
    }

    getFinalCost = (paycycle, basePrice, country) => {
        const { vat } = this.props.plans.plans.premium[0].payment_details.find(plan => plan.paycycle === paycycle);
        
        let totalCost;
        let hasVAT = false;
        if (country === 'United Kingdom') {
            hasVAT = true;
            if (paycycle === 'M' || paycycle === 'Monthly') {
                totalCost = +basePrice + (basePrice * vat) / 100;
            }
            else {
                totalCost = basePrice * 12 + (basePrice * 12 * vat) / 100;
            }
        }
        else if (paycycle === 'M' || paycycle === 'Monthly') {
            totalCost = +basePrice;
        }
        else {
            totalCost = +basePrice * 12;
        }

        return {
            totalCost: parseFloat(totalCost.toFixed(2)),
            hasVAT,
        };
    };

    getTotalCost = (count, paycycle) => {  
        const plan = this.props.plans.plans.premium[0].payment_details.find(item => item.paycycle === paycycle);

        const result = parseFloat(plan.base_price)
        ;

        return result;
    };

    render () {
        const {
            // selectedInvoice,
            // payInvoiceModalOpen,
            // newPaymentMethodModalOpen,
            // changePlanModalOpen,
            // editDetailsModalOpen,
            // cancelSubscriptionModalOpen,
            // restartSubscriptionModalOpen,
            // defaultPaymentMethod,
            // nextPaymentDateString,
            // cancellationDateString,
            // trialEndingDateString,
            // subscriptionStatus,
            // downgradeEvent,
            upgradeEvent,
            eventsList,
            // downgradeModalOpen,
            upgradeModalOpen,
            perks,
            isShowSelectSizeTierModal,
            isShowContactModal,
            annualPlanPrice,
            // currentTier
        } = this.state;

        const mpProps = this.context.selectedOrganisation ? {
            organisation: this.context.selectedOrganisation?.name,
            premium_subscriber: this.context.selectedOrganisation?.is_premium_subscriber
        } : {};

        const perksList = perks?.map((perk, i) => (
            <tbody id={perk.id} key={perk.id}>
                <tr className="sp-table-responsive-row">
                    <td colSpan="2" className="sp-table-responsive-perk">
                        {localiseText(perk.title)}
                        {perk.description && <p className="sp-perk-coming-soon">{perk.description}</p>}
                    </td>
                </tr>
                <tr className="sp-perk-row">
                    <td className="sp-perk-title">
                        {perk.description && <p className="sp-perk-coming-soon">{perk.description}</p>}
                        {localiseText(perk.title)}
                    </td>
                    <td>
                        {perk.premium_only ? (
                            <span className="spc-perks-perk-img spc-perks-perk-img-cross">
                                <CloseIcon />
                            </span>
                        ) : (
                            <span className="spc-perks-perk-img">
                                <TickIcon />
                            </span>
                        )}
                    </td>
                    <td
                        className={
                            i === perks.length - 1 ? 'sp-perk-included  sp-perk-included-last' : 'sp-perk-included'
                        }
                    >
                        <span className="spc-perks-perk-img">
                            <TickIcon />
                        </span>
                    </td>
                </tr>
            </tbody>
        ));
        
        return (
            <div className="subscription-plans-container"> 
                {this.props.subscriptionDetails?.details?.statuses.is_trial_eligible ?
                    <div className="subscription-info-banner subscription-start-trial-banner">
                        <p className="subscription-info-text">
                            <span className="subscription-info-icon">
                                <ExclamationIcon />
                            </span>
                            You have a 14-day free trial for Racecheck Premium!
                        </p>
                        <div
                            role="button"
                            className={
                                'btn sub-fixed-width-btn primary-btn modal-form-btn'
                            }
                            onClick={() => {
                                /* eslint-disable-next-line */
                                mixpanel.track('Dashboard - Subscription page - Trial banner - Upgrade to Premium click', mpProps);
                                this.toggleIsShowSelectSizeTierModal();
                            }
                            }
                        >
                            Get started now
                        </div>
                    </div>
                    :
                    <div className="subscription-start-trial-banner sp-responsive-get-started-btn">
                        <div
                            role="button"
                            className={
                                'btn sub-fixed-width-btn primary-btn modal-form-btn'
                            }
                            onClick={() => {
                                /* eslint-disable-next-line */
                                mixpanel.track('Dashboard - Subscription page - Upgrade to Premium click', mpProps);
                                this.toggleIsShowSelectSizeTierModal();
                            }
                            }
                        >
                            Get started now
                        </div>
                    </div>
                }

                <div className="subscription-plan-cards">
                    <table className="sp-table">
                        <thead>
                            <tr>
                                <th className="sp-table-perks-header">Racecheck features</th>
                                <th className="sp-table-plan">
                                    <p className="sp-title sp-title-free">Free</p>
                                    <h2 className="sp-plan-title">
                                        <span className="spc-pt-currency">
                                            {mapCurrencyToSign[annualPlanPrice?.base_price_currency]}
                                        </span>0
                                        <span className="spc-pt-month">/month</span>
                                    </h2>
                                    <p className="sp-plan-title-copy">your current plan</p>
                                </th>
                                <th className="sp-table-plan sp-table-plan-recommended">
                                    <p className="sp-title sp-title-premium">
                                        Premium
                                        {/* {currentTier === 'Tier 5' && 'from'} */}
                                    </p>
                                    <h2 className="sp-plan-title">
                                        <span className="spc-pt-currency">
                                            {mapCurrencyToSign[annualPlanPrice?.base_price_currency]}
                                        </span>
                                        {annualPlanPrice?.base_price}
                                        <span className="spc-pt-month">/month</span>
                                    </h2>
                                    <p className="sp-plan-title-copy">when billed annually</p>
                                    <div className="modal-btn-row spc-btn">
                                        <div
                                            role="button"
                                            className="btn primary-btn modal-form-btn"
                                            onClick={() => {
                                                /* eslint-disable-next-line */
                                                mixpanel.track('Dashboard - Subscription page - Upgrade to Premium click', mpProps);
                                                this.toggleIsShowSelectSizeTierModal();
                                            }
                                            }
                                        >
                                            Upgrade now
                                        </div>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        {perksList}
                        {/* eslint-disable */}
                                {/* <tr className="sp-table-responsive-row">
                                    <td colSpan="2" className="sp-table-responsive-perk">Access to the Organiser Dashboard</td>
                                </tr>
                                <tr className="sp-perk-row">
                                    <td className="sp-perk-title">Access to the Organiser Dashboard</td>
                                    <td><span className="spc-perks-perk-img"><TickIcon /></span></td>
                                    <td className="sp-perk-included"><span className="spc-perks-perk-img"><TickIcon /></span></td>
                                </tr>
                                <tr className="sp-table-responsive-row">
                                    <td colSpan="2" className="sp-table-responsive-perk">List your events and collect reviews</td>
                                </tr>
                                <tr className="sp-perk-row">
                                    <td className="sp-perk-title">List your events and collect reviews</td>
                                    <td><span className="spc-perks-perk-img"><TickIcon /></span></td>
                                    <td className="sp-perk-included"><span className="spc-perks-perk-img"><TickIcon /></span></td>
                                </tr>
                                <tr className="sp-table-responsive-row">
                                    <td colSpan="2" className="sp-table-responsive-perk">Racecheck Mini Widget</td>
                                </tr>
                                <tr className="sp-perk-row">
                                    <td className="sp-perk-title">Racecheck Mini Widget</td>
                                    <td><span className="spc-perks-perk-img"><TickIcon /></span></td>
                                    <td className="sp-perk-included"><span className="spc-perks-perk-img"><TickIcon /></span></td>
                                </tr>
                                <tr className="sp-table-responsive-row">
                                    <td colSpan="2" className="sp-table-responsive-perk">Racecheck Full Widget</td>
                                </tr>
                                <tr className="sp-perk-row">
                                    <td className="sp-perk-title">Racecheck Full Widget</td>
                                    <td><span className="spc-perks-perk-img spc-perks-perk-img-cross"><CloseIcon /></span></td>
                                    <td className="sp-perk-included"><span className="spc-perks-perk-img"><TickIcon /></span></td>
                                </tr>
                                <tr className="sp-table-responsive-row">
                                    <td colSpan="2" className="sp-table-responsive-perk">Review Analytics</td>
                                </tr>
                                <tr className="sp-perk-row">
                                    <td className="sp-perk-title">Review Analytics</td>
                                    <td><span className="spc-perks-perk-img spc-perks-perk-img-cross"><CloseIcon /></span></td>
                                    <td className="sp-perk-included"><span className="spc-perks-perk-img"><TickIcon /></span></td>
                                </tr>
                                <tr className="sp-table-responsive-row">
                                    <td colSpan="2" className="sp-table-responsive-perk">Widget Engagement Analytics <p className="sp-perk-coming-soon">COMING SOON</p></td>
                                </tr>
                                <tr className="sp-perk-row">
                                    <td className="sp-perk-title">
                                        Widget Engagement Analytics
                                        <p className="sp-perk-coming-soon">
                                            COMING SOON
                                        </p>
                                    </td>
                                    <td><span className="spc-perks-perk-img spc-perks-perk-img-cross"><CloseIcon /></span></td>
                                    <td className="sp-perk-included"><span className="spc-perks-perk-img"><TickIcon /></span></td>
                                </tr>
                                <tr className="sp-table-responsive-row">
                                    <td colSpan="2" className="sp-table-responsive-perk">Participant Sentiment Score <p className="sp-perk-coming-soon">COMING SOON</p></td>
                                </tr>
                                <tr className="sp-perk-row">
                                    <td className="sp-perk-title">
                                        Participant Sentiment Score
                                        <p className="sp-perk-coming-soon">
                                            COMING SOON
                                        </p>
                                    </td>
                                    <td><span className="spc-perks-perk-img spc-perks-perk-img-cross"><CloseIcon /></span></td>
                                    <td className="sp-perk-included"><span className="spc-perks-perk-img"><TickIcon /></span></td>
                                </tr>
                                <tr className="sp-table-responsive-row">
                                    <td colSpan="2" className="sp-table-responsive-perk">Live support</td>
                                </tr>
                                <tr className="sp-perk-row">
                                    <td className="sp-perk-title">
                                        Live Support
                                    </td>
                                    <td><span className="spc-perks-perk-img spc-perks-perk-img-cross"><CloseIcon /></span></td>
                                    <td className="sp-perk-included sp-perk-included-last"><span className="spc-perks-perk-img"><TickIcon /></span></td>
                                </tr> */}
                                {/* eslint-enable*/}
                    </table>
                </div>
                        
                {/* <div className="manage-subscription-card">
                    <div className="msc-left">
                        <p className="msc-title">RACECHECK PREMIUM FEATURES</p>
                        <ul className="msc-premium-features">
                            <li>
                                <TickIcon />Fully-featured expanding Racecheck Widget with review collection
                            </li>
                            <li>
                                <TickIcon />Widget engagement analytics to assess conversion rates
                            </li>
                            <li>
                                <TickIcon />Event and review analytics give deeper insights into your feedback
                            </li>
                            <li>
                                <TickIcon />SEO optimisation through Google rich snippets
                            </li>
                        </ul>
                    </div>
                    <div className="msc-right">
                        <div className="sp-table-plan">
                            <p className="sp-title">Starting from</p>
                            <h2 className="sp-plan-title">
                                <span className="spc-pt-currency">£</span>39
                                <span className="spc-pt-month">/month</span>
                            </h2>
                            <p className="sp-plan-title-copy">when billed annually</p>
                        </div>
                    </div>
                </div> */}

                {/* {this.props.subscriptionDetails.details.events.free + 
                this.props.subscriptionDetails.details.events.premium > 0 ?
                    <EventsList 
                        subscriptionDetails={this.props.subscriptionDetails} 
                        handleUpgradeEvent={this.handleUpgradeEvent}
                        handleDowngradeEvent={this.handleDowngradeEvent}
                        refreshEvents={this.state.refreshEvents}
                        refreshSuccess={() => this.setState({
                            refreshEvents: false
                        })}
                        openEmptyUpgradeModal={this.state.openEmptyUpgradeModal}
                    />
                    :
                    <div className="no-data-container">
                        <img src={noDataImage} className="no-data-img" alt="empty-clipboard" />
                        <p className="no-data-header">Your organisation has no events</p>
                        <p className="no-data-copy">
                            You need to add or claim your organisation&#39;s events before you can start using Racecheck Premium.
                            Head to the <Link to={'/events/events'} className="no-data-inline-link">Events</Link> page
                            to get started.
                        </p>
                    </div>
                } */}
                {/* {this.props.subscriptionDetails.details.open_invoices.length > 0 && (
                    <div className="manage-subscription-card msc-invoices">
                        <p className="msc-title">Overdue Invoices</p>
                        <table className="msc-invoice-table">
                            <thead>
                                <tr>
                                    <th>Invoice ID</th>
                                    <th>Due date</th>
                                    <th>Status</th>
                                    <th>Amount due</th>
                                    <th />
                                </tr>
                            </thead>
                            <tbody>{dueInvoices}</tbody>
                        </table>
                    </div>
                )} */}
                {/* {newPaymentMethodModalOpen && (
                    <NewPaymentMethodModal
                        toggleModal={this.toggleNewPaymentMethodModal}
                        subscriptionDetails={this.props.subscriptionDetails.details}
                        updateSubData={this.props.updateSubData}
                    />
                )}
                {payInvoiceModalOpen && (
                    <PayInvoiceModal
                        toggleModal={this.togglePayInvoiceModal}
                        subscriptionDetails={this.props.subscriptionDetails}
                        invoiceID={selectedInvoice}
                        updateSubData={this.props.updateSubData}
                    />
                )} */}
                {/* {editDetailsModalOpen && (
                    <EditDetailsModal
                        toggleModal={this.toggleEditDetailsModal}
                        subscriptionDetails={this.props.subscriptionDetails}
                        updateSubData={this.props.updateSubData}
                    />
                )}
                {changePlanModalOpen && !cancellationDateString && (
                    <ChangePlanModal
                        toggleModal={this.toggleChangePlanModal}
                        subscriptionDetails={this.props.subscriptionDetails}
                        updateSubData={this.props.updateSubData}
                        trialEndingDateString={trialEndingDateString}
                    />
                )} */}
                {/* {cancelSubscriptionModalOpen && (
                    <CancelSubscriptionModal
                        toggleModal={this.toggleCancelSubscriptionModal}
                        subscriptionDetails={this.props.subscriptionDetails}
                        updateSubData={this.props.updateSubData}
                    />
                )}
                {restartSubscriptionModalOpen && (
                    <RestartSubscriptionModal
                        toggleModal={this.toggleRestartSubscriptionModal}
                        subscriptionDetails={this.props.subscriptionDetails}
                        updateSubData={this.props.updateSubData}
                        totalCost={totalCost}
                        hasVAT={hasVAT}
                    />
                )} */}
                {/* {downgradeModalOpen && 
                    <DowngradeEventModal 
                        event={downgradeEvent}
                        subscriptionDetails={this.props.subscriptionDetails}
                        onClose={this.handleDowngradeCancel} 
                        getFinalCost={this.getFinalCost}
                        getTotalCost={this.getTotalCost}
                    />
                } */}
                {upgradeModalOpen &&
                    <CreateSubscriptionModal 
                        event={upgradeEvent}
                        events={eventsList} 
                        subscriptionDetails={this.props.subscriptionDetails} 
                        plans={this.props.plans}
                        onClose={this.handleUpgradeCancel} 
                        getFinalCost={this.getFinalCost}
                        getTotalCost={this.getTotalCost}
                        handleUpgradeCancel={this.handleUpgradeCancel}
                    />
                }

                {isShowSelectSizeTierModal && 
                    <SelectSizeTierModal 
                        onClose={this.toggleIsShowSelectSizeTierModal}
                        handleContinue={this.handleContinueUpgradeToPremium} 
                    />}

                {
                    isShowContactModal && 
                    <ContactModal 
                        onClose={this.toggleContactModal}
                        closeSizeTierModal={this.toggleIsShowSelectSizeTierModal}
                    />
                }
            </div>
        );
    }

};

FreeAccount.propTypes = {
    subscriptionDetails: PropTypes.shape({
        details: PropTypes.shape({
            customer: PropTypes.shape({
                country: PropTypes.string
            }),
            statuses: PropTypes.shape({
                is_trial_eligible: PropTypes.bool
            }),
            events: PropTypes.shape({
                premium: PropTypes.number,
                free: PropTypes.number,
            })
        })
    }),
    plans: PropTypes.shape({
        plans: PropTypes.shape({
            premium: PropTypes.arrayOf(
                PropTypes.shape({
                    payment_details: PropTypes.arrayOf(
                        PropTypes.shape({
                            paycycle: PropTypes.string
                        })
                    )
                })
            )
        })
    }),
    updateSubData: PropTypes.func
};

export default withRouter(FreeAccount);